var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import classNames from 'classnames';
import clsx from 'clsx';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import { getPatientGroupType, } from 'ziphy-web-shared/basic/entities/appointments';
import { Badge, Title } from 'ziphy-web-shared/basic/lib/simple';
import clientService from '@services/client';
import ActionButtons from '@nedoShared/features/appointment/apptButtons/ApptButtons';
import styles from './ApptHeader.module.scss';
const ApptHeader = ({ byRoute, className, isOpen = true, setIsOpen }) => {
    const { status, fullAppt } = byRoute;
    const { appointment, service, liveqService } = fullAppt;
    const groupType = getPatientGroupType(appointment);
    const liveqServiceId = appointment === null || appointment === void 0 ? void 0 : appointment.liveqServiceId;
    const liveqId = appointment === null || appointment === void 0 ? void 0 : appointment.liveqId;
    const parentAppointmentId = appointment.parentAppointmentId;
    const shouldFetchParent = useMemo(() => {
        return Boolean(!liveqId && parentAppointmentId);
    }, [liveqId, parentAppointmentId]);
    const [parentAppt, setParentAppt] = useState(undefined);
    useEffect(() => {
        let ignore = false;
        const fetchParent = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                if (!shouldFetchParent)
                    return;
                const idNum = Number(parentAppointmentId);
                const resAppt = yield clientService.getOneAppointment({
                    id: Number.isNaN(idNum) ? parentAppointmentId : idNum,
                    skipAlert: true,
                    getEvents: false,
                    checkRoles: false,
                });
                if (!ignore)
                    setParentAppt(resAppt === null || resAppt === void 0 ? void 0 : resAppt.prepared);
            }
            catch (e) { }
        });
        void fetchParent();
        return () => {
            ignore = true;
        };
    }, [shouldFetchParent, parentAppointmentId]);
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [_jsx(Title, Object.assign({ size: 'h1', className: styles.title }, { children: liveqService ? liveqService.displayName : service.name })), _jsxs("div", Object.assign({ className: styles.controls }, { children: [_jsxs("div", Object.assign({ className: styles.badges }, { children: [_jsx(Badge, Object.assign({ mode: ['secondary-dark', 'lg', 'rounded'] }, { children: groupType.label })), _jsx(Badge, Object.assign({ mode: [status.isProgress ? 'success' : 'secondary-dark', 'lg', 'rounded'] }, { children: status.texts.status })), _jsx("div", Object.assign({ className: clsx(styles.chevron, { [styles.chevronOpen]: isOpen }), onClick: () => setIsOpen(!isOpen) }, { children: _jsx(Icon, { type: 'chevron' }) }))] })), _jsx(ActionButtons, { parentAppt: parentAppt, byRoute: byRoute, className: styles.buttons, isOpen: isOpen })] }))] })));
};
export default observer(ApptHeader);
